module.exports = __webpack_public_path__ + "img/formador-25.605ca8f3.png";